import { useContext, useEffect, useRef } from 'react';
import { Box } from '@mui/material';
import { useMeasureFormatter } from '../measure-unit/measureFormatter';
import { useAttributeFormatter } from '../../utils/attributeFormatter';
import { DeviceContext } from '../../context/DeviceContext';
import { ChartRenderer } from './renderer/ChartRenderer';
import { ChartRendererContext } from './renderer/ChartRendererContext';
import { ChartTooltip } from './ChartTooltip';

export function Chart({
  className = '',
  renderer,
  height = undefined,
}: {
  className?: string;
  renderer: ChartRenderer;
  height?: string;
}) {
  const divRef = useRef(null as HTMLDivElement | null);

  const { size } = useContext(DeviceContext);

  const { measureFormatter } = useMeasureFormatter();
  const { attributeFormatter } = useAttributeFormatter();

  const currentRenderer = renderer;
  useEffect(() => {
    if (divRef.current && divRef.current instanceof HTMLDivElement) {
      const ctx: ChartRendererContext = {
        measureFormatter,
        attributeFormatter,
      };
      currentRenderer.el = divRef.current;
      currentRenderer.rerender(ctx);
    }
  }, [size, currentRenderer, measureFormatter, attributeFormatter]);

  return (
    <>
      <ChartTooltip renderer={currentRenderer} />
      <Box component="div" sx={{ height }}>
        <div className={className} ref={divRef} />
      </Box>
    </>
  );
}
